/**
 * @constant __CONTEXT_FIELD_LOGIN__ 登录，判断是否已经登录
 * @example { useIsAccessTokenValid: useIsAccessTokenValid }
 */
export const __CONTEXT_FIELD_LOGIN__ = '$login'; // 登录

/**
 * @constant __CONTEXT_FIELD_LOGIN__ 退出，执行退出逻辑（删除本地缓存等操作）
 * @example { useLogOut: useLogOut }
 */
export const __CONTEXT_FIELD_LOGOUT__ = '$logOut'; // 退出

/**
 * @constant __CONTEXT_WTB_PRODUCT__ wtb的product上下文
 * @example { product: { productModelNumber, productName } }
 */
export const __CONTEXT_WTB_PRODUCT__ = '$wtbProduct'; // wtb的product上下文

export const _SHOPIFY_PRODUCT_TYEP = 'product'; // shopify的product接口缓存

export const  _SHOPIFY_PRODUCT_ID_TYEP = 'product-id'; // hopify的product-id接口缓存

export const __SHOPIFY_PRODUCT_INFO__ = 'product-info' // shopify的product 通过id 获取产品信息接口缓存

export const _SHOPIFY_ADDRESS_API_DATA = 'addressApiData'; // shopify 地址数据缓存，国家/省份...

export const __SHOPIFY_URL__ = '$shopifyUrl'; // shopify 登录url 新C4A
